import { Box, Typography } from '@mui/material';
import LegalLayout from './LegalLayout';

const Section = ({ title, children }) => (
  <Box sx={{ mb: 5 }}>
    <Typography sx={{
      fontFamily: 'Frank Ruhl Libre, serif',
      fontWeight: 700,
      fontSize: '1.2rem',
      color: '#1e3a5f',
      mb: 1.5,
    }}>
      {title}
    </Typography>
    {children}
  </Box>
);

const P = ({ children }) => (
  <Typography sx={{
    fontFamily: 'Heebo, sans-serif',
    fontSize: '0.93rem',
    color: '#3a4a5a',
    lineHeight: 1.9,
    mb: 1.2,
  }}>
    {children}
  </Typography>
);

const PrivacyPage = () => (
  <LegalLayout title="מדיניות פרטיות" subtitle="עודכן לאחרונה: ינואר 2025">
    <Section title="1. מבוא">
      <P>
        inorai מחויבת להגנה על פרטיות המשתמשים. מדיניות זו מסבירה אילו נתונים אנו אוספים,
        כיצד אנו משתמשים בהם ואיך תוכלו לשלוט בהם.
      </P>
    </Section>

    <Section title="2. מידע שאנו אוספים">
      <P>
        <strong>מידע שמסרתם:</strong> שם, כתובת דואר אלקטרוני, שם הארגון ופרטי תשלום
        (מעובדים דרך ספק תשלומים מאובטח — אנו לא מאחסנים פרטי כרטיס אשראי).
      </P>
      <P>
        <strong>מידע טכני:</strong> כתובת IP, סוג דפדפן, מערכת הפעלה, עמודים שנצפו ומשך הגלישה —
        לצרכי אבחון ושיפור השירות.
      </P>
      <P>
        <strong>תוכן שיצרתם:</strong> לוחות תצוגה, טקסטים, תמונות וכל תוכן שהעלתם לפלטפורמה.
      </P>
    </Section>

    <Section title="3. כיצד אנו משתמשים במידע">
      <P>אנו משתמשים במידע לצורך:</P>
      <P>· מתן השירות, אחזקתו ושיפורו</P>
      <P>· שליחת עדכונים טכניים והודעות חשובות</P>
      <P>· תמיכה טכנית ומענה לפניות</P>
      <P>· ניתוח שימוש אנונימי לשיפור חוויית המשתמש</P>
      <P>· עמידה בדרישות חוקיות</P>
    </Section>

    <Section title="4. שיתוף מידע עם צדדים שלישיים">
      <P>
        אנו <strong>לא מוכרים</strong> מידע אישי לצדדים שלישיים. אנו עשויים לשתף מידע עם:
      </P>
      <P>
        · <strong>ספקי שירות:</strong> כגון שירותי אחסון ענן, שליחת מיילים ועיבוד תשלומים,
        בכפוף להסכמי סודיות.
      </P>
      <P>
        · <strong>רשויות:</strong> כאשר נדרש על פי חוק.
      </P>
    </Section>

    <Section title="5. עוגיות (Cookies)">
      <P>
        אנו משתמשים בעוגיות הכרחיות לתפעול השירות (שמירת התחברות, העדפות שפה) ועוגיות
        אנליטיות אנונימיות לשיפור ביצועים. ניתן להגדיר את הדפדפן לחסום עוגיות, אך הדבר
        עלול לפגוע בחלק מפונקציות השירות.
      </P>
    </Section>

    <Section title="6. אבטחת מידע">
      <P>
        אנו נוקטים אמצעי אבטחה תקניים: הצפנת HTTPS, גישה מוגבלת לנתונים על בסיס
        "צורך לדעת", ועדכוני אבטחה שוטפים. עם זאת, אין אבטחה מוחלטת ברשת האינטרנט
        ואיננו יכולים להבטיח הגנה מפני כל איום.
      </P>
    </Section>

    <Section title="7. שמירת נתונים">
      <P>
        נתוני חשבון פעיל נשמרים כל עוד החשבון קיים. לאחר סגירת חשבון, נמחק את הנתונים
        תוך 90 יום, למעט מקרים בהם שמירה נדרשת על פי חוק.
      </P>
    </Section>

    <Section title="8. זכויותיכם">
      <P>בהתאם לחוק הגנת הפרטיות הישראלי, יש לכם זכות:</P>
      <P>· לעיין במידע שנאסף עליכם</P>
      <P>· לתקן מידע שגוי</P>
      <P>· לבקש מחיקת המידע שלכם</P>
      <P>· לקבל עותק של המידע שלכם (ניידות מידע)</P>
      <P>
        לממש זכויות אלה, פנו אלינו:{' '}
        <Box
          component="a"
          href="mailto:ineraigroup@gmail.com"
          sx={{ color: '#9a7209', textDecoration: 'none', fontWeight: 600, '&:hover': { textDecoration: 'underline' } }}
        >
          ineraigroup@gmail.com
        </Box>
      </P>
    </Section>

    <Section title="9. שינויים במדיניות">
      <P>
        עדכונים מהותיים במדיניות יועברו בהודעה מוקדמת במייל. השימוש המשך בשירות
        לאחר עדכון מהווה הסכמה למדיניות המעודכנת.
      </P>
    </Section>

    <Section title="10. יצירת קשר">
      <P>
        לכל שאלה בנושא פרטיות:{' '}
        <Box
          component="a"
          href="mailto:ineraigroup@gmail.com"
          sx={{ color: '#9a7209', textDecoration: 'none', fontWeight: 600, '&:hover': { textDecoration: 'underline' } }}
        >
          ineraigroup@gmail.com
        </Box>
      </P>
    </Section>
  </LegalLayout>
);

export default PrivacyPage;
